export default __webpack_public_path__ + "static/media/clean-kitchen.f5e449a8.jpeg";